const NoPage = () => {
   return <h1 id="error404">404</h1>;
 };
 
 export default NoPage;